import {
  useCheckIfSubscriptionFeatureActiveBroker,
  ViewerContext,
} from "dash-ui";
import { useContext } from "react";

export const useCheckFreeLimitedUser = () => {
  const { account, broker } = useContext(ViewerContext);
  const { isSubscriptionActive } = useCheckIfSubscriptionFeatureActiveBroker();

  let isFreeLimitedUser = false;

  // For now only SSO users will have free limited access
  if (account?.ssoId && (!broker || !isSubscriptionActive)) {
    isFreeLimitedUser = true;
  }

  return { isFreeLimitedUser };
};
